const namesAndHelpersObject = {
    lead_time: {
        name: "Lead Time",
        helper: "Lead time is the time it takes to complete a task from start to finish.",
    },
    in_progress: {
        name: "In Progress Time",
        helper: "The time a task or project is being worked on.",
    },
    under_review: {
        name: "Under Review Time",
        helper: "Time spent in QA and reviewing.",
    },
    in_progress_meeting: {
        name: "Daily Time in meetings (in progress)",
        helper: "Average daily time spent in meetings while the task was in progress",
    },
    this_active_commit_days_under_review: {
        name: "Active task commit days (under review)",
        helper: "The proportion of days that you committed code to this task to the days the task was under review (ie commit days/under review days)",
    },
    this_review_pickup_lag: {
        name: "Review Pickup Lag",
        helper: "Time between a task being ready for QA and getting picked up for review (time between last commit (before comments start) and 1st comment)",
    },
    under_review_meeting: {
        name: "Daily Time in meetings (under review)",
        helper: "Average daily time spent in meetings while the task was in under review",
    },
    in_progress_chatting: {
        name: "Daily Time chatting (in progress)",
        helper: "Average daily time spent chatting while the task was in progress",
    },
    under_review_chatting: {
        name: "Daily Time chatting (under review)",
        helper: "Average daily time spent chatting while the task was in under review",
    },
    commit_lag_in_progress: {
        name: "Commit Lag (in progress)",
        helper: "The time difference (ie lag) between subsequent task commits (while in progress). Potential causes for this lag include task difficulty, code complexity, breaks in the flow, distractions and others.",
    },
    this_active_commit_days_in_progress: {
        name: "Active commit days (in progress)",
        helper: "The ratio of days with commits to the task over the overall days in progress of the task",
    },
    this_coding_pickup_lag: {
        name: "Coding pickup lag",
        helper: "Time between someone commenting and the subsequent commit to address the comment (if needed).",
    },

    //     This is where the negligible data names start.
    other_active_commit_days_under_review: {
        name: "Active other tasks commit days (under review)",
        helper: "The proportion of days that you committed code to other tasks to the days the task was under review (ie commit days/under review days)",
    },
    other_active_commit_days_in_progress: {
        name: "Other task commit days (in progress)",
        helper: "The ratio of days with commits to the other tasks over the overall days in progress of the task",
    },
    comment_count: {
        name: "Number of comments",
        helper: "",
    },
    wip: {
        name: "Work In Progress",
        helper: "",
    },
    this_commit_count_per_day_in_progress: {
        name: "Number of commits per day (in progress)",
        helper: "",
    },
    this_commit_count_in_progress: {
        name: "Number of commits (in progress)",
        helper: "",
    },
    this_commit_count_per_day_under_review: {
        name: "Number of commits per day (under review)",
        helper: "",
    },
    this_commit_count_under_review: {
        name: "Number of commits (under review)",
        helper: "",
    },
    this_active_commit_days: {
        name: "Commit days",
        helper: "",
    },
    this_total_in_progress: {
        name: "Lines of code (in progress)",
        helper: "",
    },
    this_total_per_day_in_progress: {
        name: "Lines of code per day (in progress)",
        helper: "",
    },
    this_total_under_review: {
        name: "Lines of code (under review)",
        helper: "",
    },
    this_total_per_day_under_review: {
        name: "Lines of code per day (under review)",
        helper: "",
    },
    this_files_in_progress: {
        name: "Files changed (in progress)",
        helper: "",
    },
    this_files_per_day_in_progress: {
        name: "Files changed per day (in progress)",
        helper: "",
    },
    this_files_under_review: {
        name: "Files changed (under review)",
        helper: "",
    },
    this_files_per_day_under_review: {
        name: "Files changed per day (under review)",
        helper: "",
    },
    this_files: {
        name: "Files changed (overall)",
        helper: "",
    },
    this_files_per_day: {
        name: "Files changed per day (overall)",
        helper: "",
    },
    this_coding_languages_in_progress: {
        name: "Coding languages (in progress)",
        helper: "",
    },
    this_coding_languages_under_review: {
        name: "Coding languages (under review)",
        helper: "",
    },
    this_coding_languages: {
        name: "Coding languages (overall)",
        helper: "",
    },
    other_commit_count_in_progress: {
        name: "Commits to other tasks (in progress)",
        helper: "",
    },
    other_commit_count_per_day_under_review: {
        name: "Commits to other tasks per day (under review)",
        helper: "",
    },
    other_commit_count_under_review: {
        name: "Commits to other tasks (under review)",
        helper: "",
    },
    other_commit_days: {
        name: "Commit days to other tasks (overall)",
        helper: "",
    },
    other_active_commit_days: {
        name: "Ratio of commit days to other tasks (overall)",
        helper: "",
    },
    other_total_in_progress: {
        name: "Lines changed to other tasks (in progress)",
        helper: "",
    },
    other_total_per_day_in_progress: {
        name: "Lines changed to other tasks per day (in progress)",
        helper: "",
    },
    other_total_under_review: {
        name: "Lines changed to other tasks (under review)",
        helper: "",
    },
    other_total_per_day_under_review: {
        name: "Lines changed to other tasks per day (under review)",
        helper: "",
    },
    other_files_in_progress: {
        name: "Files changed to other tasks (in progress)",
        helper: "",
    },
    other_files_per_day_in_progress: {
        name: "Files changed to other tasks per day (in progress)",
        helper: "",
    },
    other_files_under_review: {
        name: "Files changed to other tasks (under review)",
        helper: "",
    },
    other_files_per_day_under_review: {
        name: "Files changed to other tasks per day (under review)",
        helper: "",
    },
    other_files: {
        name: "Files changed to other tasks (overall)",
        helper: "",
    },
    other_files_per_day: {
        name: "Files changed to other tasks per day (overall)",
        helper: "",
    },
    other_coding_languages_in_progress: {
        name: "Coding languages to other tasks (in progress)",
        helper: "",
    },
    other_coding_languages_under_review: {
        name: "Coding languages to other tasks (under review)",
        helper: "",
    },
    other_coding_languages: {
        name: "Coding languages to other tasks (overall)",
        helper: "",
    },
    this_comment_count_in_progress: {
        name: "Number of comments (in progress)",
        helper: "",
    },
    this_comment_count_per_day_in_progress: {
        name: "Number of comments per day (in progress)",
        helper: "",
    },
    this_comment_days_in_progress: {
        name: "Number of days with comments (in progress)",
        helper: "",
    },
    this_active_comment_days_in_progress: {
        name: "Proportion of days with comments (in progress)",
        helper: "",
    },
    this_comment_count_under_review: {
        name: "Number of comments (under review)",
        helper: "",
    },
    this_comment_count_per_day_under_review: {
        name: "Number of comments per day (under review)",
        helper: "",
    },
    this_comment_days_under_review: {
        name: "Number of days with comments (under review)",
        helper: "",
    },
    this_active_comment_days_under_review: {
        name: "Proportion of days with comments (under review)",
        helper: "",
    },
    this_comment_days: {
        name: "Number of days with comments (overall)",
        helper: "",
    },
    this_active_comment_days: {
        name: "Proportion of days with comments (overall)",
        helper: "",
    },
    other_comment_count_in_progress: {
        name: "Number of comments to other tasks (in progress)",
        helper: "",
    },
    other_comment_count_per_day_in_progress: {
        name: "Number of comments to other tasks per day (in progress)",
        helper: "",
    },
    other_comment_days_in_progress: {
        name: "Number of days with comments to other tasks (in progress)",
        helper: "",
    },
    other_active_comment_days_in_progress: {
        name: "Proportion of days with comments to other tasks (in progress)",
        helper: "",
    },

    other_comment_count_under_review: {
        name: "Number of comments to other tasks (under review)",
        helper: "",
    },
    other_comment_count_per_day_under_review: {
        name: "Number of comments to other tasks per day (under review)",
        helper: "",
    },
    other_comment_days_under_review: {
        name: "Number of days with comments to other tasks (under review)",
        helper: "",
    },
    other_active_comment_days_under_review: {
        name: "Proportion of days with comments to other tasks (under review)",
        helper: "",
    },
    other_comment_days: {
        name: "Number of days with comments to other tasks (overall)",
        helper: "",
    },
    other_active_comment_days: {
        name: "Proportion of days with comments to other tasks (overall)",
        helper: "",
    },
    in_progress_active_chatting_days: {
        name: "Proportion of days with chatting (in progress)",
        helper: "",
    },
    under_review_active_chatting_days: {
        name: "Proportion of days with chatting (under review)",
        helper: "",
    },
    chatting_active_days: {
        name: "Proportion of days with chatting (overall)",
        helper: "",
    },
    in_progress_active_meeting_days: {
        name: "Proportion of days with meetings (in progress)",
        helper: "",
    },
    under_review_active_meeting_days: {
        name: "Proportion of days with meetings (under review)",
        helper: "",
    },
    meeting_active_days: {
        name: "Proportion of days with meetings (overall)",
        helper: "",
    },
    commit_lag_under_review: {
        name: "Difference of time between two subsequent commits (under review)",
        helper: "",
    },

    this_commit_days_in_progress: {
        name: "Days with commits while in progress",
        helper: "The days while the PR was in progress for which the PR have commits",
    },
    this_commit_days_under_review: {
        name: "Days with commits while under review",
        helper: "The days while the PR was under review for which the PR have commits",
    },
    other_commit_days_in_progress: {
        name: "Days with commits on other tasks while this one is in progress",
        helper: "The days while the PR was in progress for which other PRs had commits",
    },
    other_commit_days_under_review: {
        name: "Days with commits on other tasks while this one is under review",
        helper: "The days while the PR was under review for which other PRs had commits",
    },
    in_progress_focus: {
        name: "Focus time while in progress",
        helper: "The available focus time while the PR was in progress",
    },
    under_review_focus: {
        name: "Focus time while under review",
        helper: "The available focus time while the PR was under review",
    },
};

export default namesAndHelpersObject;
